angular
  .module('picmonicng')
  .directive('ellipsisMenu', [
    '$timeout',
    function ($timeout) {
      return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
          icon: '@',
          iconClass: '@',
          title: '@',
          ellipsisRole: '=',
          ellipsisTabindex: '=',
          ellipsisClick: '=',
        },
        template:
          '<div class="ellipsis-menu">' +
          '<div class="ellipsis-wrapper pls-blue-steel" ellipsis-role="{{ellipsisRole}}" ellipsis-tabindex="{{ellipsisTabindex}}" tabindex="0" click-on-enter>' +
          '<i class="material-icons" material-icon="{{icon?icon:\'more_horiz\'}}" ng-class="iconClass">{{icon?icon:\'more_horiz\'}}</i>' +
          '</div>' +
          '<div ng-if="open" class="card-options-submenu" ng-transclude>' +
          '</div>' +
          '</div>',
        link: function (scope, element, attrs) {
          scope.open = false;
          if (!scope.title) {
            scope.title = 'More Options';
          }

          // Handle pressing ESC & tabbing out of menu
          element.bind('keydown keypress', function (e) {
            scope.$apply(function () {
              if (scope.open && e.keyCode == 27) {
                scope.closeMenu();
              } else if (e.keyCode == 9 && element.find('ul').not('.ng-hide').find('li').last().is(':focus')) {
                scope.closeMenu();
              } else if (e.keyCode == 9 && element.find('ul').not('.ng-hide').find('a').last().is(':focus')) {
                scope.closeMenu();
              }
            });
          });

          element.find('.ellipsis-wrapper').bind('click', function (e) {
            // Stop propagation in case this is a keyboard-triggered event
            e.stopPropagation();
            e.preventDefault();
            scope.$apply(function () {
              scope.addClickToClose();
              scope.open = true;
              if (typeof scope.ellipsisClick === 'function') {
                scope.ellipsisClick();
              }
            });
          });

          element.bind('click', function (e) {
            e.stopPropagation();
          });

          function clickHandler(e) {
            if (
              scope.open === true &&
              element[0] != e.target &&
              !angular.element(element).has(angular.element(e.target)).length
            ) {
              scope.$apply(function () {
                scope.closeMenu();
              });
            }
          }

          scope.addClickToClose = function () {
            document.body.addEventListener('click', clickHandler, true);
          };

          scope.removeClickToClose = function () {
            document.body.removeEventListener('click', clickHandler, true);
          };

          scope.closeMenu = function () {
            scope.removeClickToClose();

            scope.open = false;
          };
        },
        controller: [
          '$scope',
          function ($scope) {
            this.closeMenu = function () {
              $scope.closeMenu();
            };
          },
        ],
      };
    },
  ])
  .directive('ellipsisMenuClose', [
    function () {
      return {
        restrict: 'A',
        require: '^ellipsisMenu',
        link: function (scope, element, attrs, ellipsisMenu) {
          element.bind('click', function () {
            scope.$apply(function () {
              ellipsisMenu.closeMenu();
            });
          });
        },
      };
    },
  ]);
